/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FinancialTariff } from '../models/FinancialTariff';
import type { PatchedFinancialTariff } from '../models/PatchedFinancialTariff';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FinancialTariffService {

  /**
   * List tariff values
   * Tariff values of the product: standard premium per insured person, insured sum and deductible (management view — returns every variant). None of them can be changed by a seller: the correction coefficient is the only lever.
   * @param ordering Ordering fields: code
   * @returns FinancialTariff 
   * @throws ApiError
   */
  public static financialTariffList(
ordering?: string,
): CancelablePromise<Array<FinancialTariff>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/financial/tariff/',
      query: {
        'ordering': ordering,
      },
    });
  }

  /**
   * Retrieve tariff values
   * Management view — reference table, seeded by defaults(), no create/delete via API.
   * @param code 
   * @returns FinancialTariff 
   * @throws ApiError
   */
  public static financialTariffRetrieve(
code: 'standard',
): CancelablePromise<FinancialTariff> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/financial/tariff/{code}/',
      path: {
        'code': code,
      },
    });
  }

  /**
   * Update tariff values
   * Editable by an admin only.
   * @param code 
   * @param requestBody 
   * @returns FinancialTariff 
   * @throws ApiError
   */
  public static financialTariffPartialUpdate(
code: 'standard',
requestBody?: PatchedFinancialTariff,
): CancelablePromise<FinancialTariff> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/financial/tariff/{code}/',
      path: {
        'code': code,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

}
